import React, { Fragment } from "react";
import {
  UncontrolledDropdown,
  DropdownToggle,
  Row,
  Col,
  ListGroup,
  ListGroupItem,
  DropdownMenu,
} from "reactstrap";
import moment from "moment";
// react library that creates nice scrollbar on windows devices
import PerfectScrollbar from "react-perfect-scrollbar";
import { getUserDetail } from "services/http/auth";
import { broadCastService } from "services/notifications/BroadCastService";
import signalR from "services/signalR/signalR";
import { notificationService } from "services/notifications/NotificationService";
import appConstant from "constants/app";
import { CalendarNotify } from "./notificationTypes/calendarNotify";
import { CalendarReminderNotify } from "./notificationTypes/calendarReminderNotify";
import { PushNotificationNotify } from "./notificationTypes/pushNotificationNotify";
import { NewLeadAddedNotify } from "./notificationTypes/newLeadAddedNotify";
import * as actionTypes from "constants/actionType";
import { connect } from "react-redux";
import notificationAlertSrc from "../../assets/audio/chime_002.mp3";
import { RealTimeNotificationNotify } from "./notificationTypes/realTimeNotificationNotify";
import { companyChange } from "services/http/auth";
import * as utils from "services/utility/utils";
import manageOverRideService from "services/http/managerOverride/manageOverRideService";

const companies = appConstant.COMPANIES_CODES;

class SignalrNotification extends React.Component {
  audio = React.createRef();
  state = {
    signalR1: signalR.getInstance1(companies[0]?.code),
    signalR2: signalR.getInstance2(companies[1]?.code),
    notificationSubscription: null,
    notifications: [],
    isOpen: false,
  };

  componentDidMount = () => {
    const { signalR1, signalR2 } = this.state;
    const companies = appConstant.COMPANIES_CODES;
    if (companies.length !== 2) {
      return;
    }

    const user1 = getUserDetail(companies[0].code);
    if (user1) {
      signalR1.start(user1.id);
    }

    const user2 = getUserDetail(companies[1].code);
    if (user2) {
      signalR2.start(user2.id);
    }

    const notificationSubscription = broadCastService
      .receiver()
      .subscribe(this.onNotificationReceived);
    this.setState({ notificationSubscription });
  };

  onNotificationReceived = (notification) => {    
    if (!appConstant.signalREvents.some((x) => x === notification.type)) {
      // MAY WE WILL REMOVE THIS BROADCART SERIVCE BECAUSE IT CALL EVERY TIME WHEN ANY BROADCASTE SERIVCE CALLED.
      return;
    }

    if (notification.type === "calendarDispositionNotify") {
      // Have done by alert.**********
      return;
    }
    const { notifications } = this.state;
    const _notification = {
      ...notification,
      isSeen: false,
    };
    this.setState({ notifications: [...notifications, _notification] });
    this.audio.current.play();
    this.onNotificationAlert(_notification);
  };

  componentWillUnmount = () => {
    const { signalR1, signalR2, notificationSubscription } = this.state;
    notificationSubscription.unsubscribe();
    signalR1.stop();
    signalR2.stop();
  };

  saveDispositionStatus = (
    dispositionStatusId,
    appointmentId,
    userId,
    index
  ) => {
    this.saveDispositionStatus(
      dispositionStatusId,
      appointmentId,
      userId,
      index
    );
  };

  redirectTicketNotification = () => {
    // TO DO ..........................
  };

  // ONLY FOR TESTING NOW***********************NEED TO CHNAGE THE MESSAGE*********
  extractNotificationMessage = (notification, index) => {
    const { type, data } = notification;
    switch (type) {
      case "calendarReminderNotify": {
        return (
          <CalendarReminderNotify
            key={index}
            data={data}
            type={type}
            index={index}
            onClientRedirect={this.onClientRedirect}
            removeNotificationAndClose={this.removeNotificationAndClose}
          />
        );
      }
      case "calendarNotify": {
        return (
          <CalendarNotify
            data={data}
            key={index}
            type={type}
            index={index}
            onClientRedirect={this.onClientRedirect}
            removeNotificationAndClose={this.removeNotificationAndClose}
          />
        );
      }
      // case 'calendarDispositionNotify': // TO DO (NEED TO REMOVE ONCE FINIALIZE THE VERSION) **************************/////////////************* */
      //     {
      //         return <CalendarDispositionNotify
      //             key={index}
      //             data={data}
      //             index={index}
      //             saveDispositionStatus={this.saveDispositionStatus}
      //             removeNotificationAndClose={this.removeNotificationAndClose} />
      //     }
      case "pushNotificationNotify": {
        return (
          <PushNotificationNotify
            key={index}
            data={data}
            message={this.getPushNotificationMessage(data)}
            index={index}
            type={type}
            onClientRedirect={this.onClientRedirect}
            removeNotificationAndClose={this.removeNotificationAndClose}
          />
        );
      }
      case "newLeadAddedNotify": {
        return (
          <NewLeadAddedNotify
            key={index}
            data={data}
            index={index}
            type={type}
            onClientRedirect={this.onClientRedirect}
            removeNotificationAndClose={this.removeNotificationAndClose}
          />
        );
      }

      case "realTimeNotificationNotify": {
        return (
          <RealTimeNotificationNotify
            key={index}
            data={data}
            index={index}
            type={type}
            onRedirectRealTimeNotification={this.onRedirectRealTimeNotification}
            removeNotificationAndClose={this.removeNotificationAndClose}
          />
        );
      }
      // case 'ticketAddNotify':
      //     {
      //         return <TicketAddNotify data={data} index={index} edirectTicketNotification={this.redirectTicketNotification} />;
      //     }
      // case 'ticketUpdateNotify':
      //     {
      //         return <TicketUpdateNotify
      //             data={data}
      //             index={index}
      //             redirectNotification={this.redirectNotification}
      //             redirectTicketNotification={this.redirectTicketNotification} />;
      //     }

      // case 'ticketResolvedNotify':
      //     {
      //         return <TicketResolvedNotify
      //             data={data}
      //             index={index}
      //             redirectNotification={this.redirectNotification}
      //             redirectTicketNotification={this.redirectTicketNotification} />;
      //     }
      // case 'ticketClosedNotify':
      //     {
      //         return <TicketClosedNotify
      //             data={data}
      //             index={index}
      //             redirectNotification={this.redirectNotification}
      //             redirectTicketNotification={this.redirectTicketNotification} />;
      //     }
      // case 'ticketNoteAddNotify':
      //     {
      //         return <TicketNoteAddNotify data={data}
      //             index={index}
      //             redirectNotification={this.redirectNotification}
      //             redirectTicketNotification={this.redirectTicketNotification} />;
      //     }
      default:
        return <></>;
    }
  };

  toggle = () => {
    const isOpen = !this.state.isOpen;
    if (isOpen) {
      this.onMarkAsRead();
    }

    this.setState({ isOpen });
  };

  onMarkAsRead = () => {
    const { notifications } = this.state;
    if (notifications.length === 0) {
      return;
    }

    notifications.forEach((element) => {
      element.isSeen = true;
    });
    this.setState({ notifications });
  };

  onNotificationClick = (e, data, type) => {
    e.preventDefault();
    if (data.contractId !== "00000000-0000-0000-0000-000000000000") {
      this.onClientRedirect(data.contractId, -1, data, type);
    }
  };

  onRealTimeNotification = (e, data, type) => {
    e.preventDefault();
    this.onRedirectRealTimeNotification(data, -1, type);
  };

  onRedirectRealTimeNotification = (data, index, type) => {
    const reference = data.reference;
    this.onClientRedirect(reference, index, data, type);
  };

  onClientRedirect = (ref, index, data, type) => {
    if (data === null) {
      return;
    }
    const action = this.extractRedirectAction(type, data);
    if (action !== "AuthRequest") {
      this.props.history.push(
        `/admin/redirect/${ref}/${data.companyCode}?action=${action}`
      );
    }

    if (index >= 0) {
      this.removeNotificationAndClose(index);
    }
  };

  extractRedirectAction = (type, data) => {
    switch (type) {
      case "calendarNotify":
        return "ClientRedirectUrl";
      case "calendarReminderNotify":
        return "ClientRedirectUrl";
      case "pushNotificationNotify":
        return "ClientHistoryUrl";
      case "newLeadAddedNotify":
        return "ClientRedirectUrl";
      case "realTimeNotificationNotify":
        return data.category;
      default:
        return "ClientRedirectUrl";
    }
  };

  removeNotificationAndClose = (index, skipClose) => {
    const { notifications } = this.state;
    if (notifications.length > 0) {
      notifications.splice(index, 1);
    }
    const isOpen = skipClose ? true : false;
    this.setState({ notifications, isOpen });
  };

  onNotificationAlert = ({ type, data }) => {
    let message = null;
    let _type = "default";
    let alertClass = "alert-default";
    switch (type) {
      case "calendarNotify":
        _type = "warning ";
        alertClass = "alert-warning";
        message = this.extractCalendarNotify(data, type, alertClass);
        break;

      case "calendarReminderNotify":
        message = this.extractCalendarReminderNotify(data, type, alertClass);
        break;

      //case 'calendarDispositionNotify': // TO DO (NEED TO REMOVE ONCE FINIALIZE THE VERSION) **************************/////////////************* */
      //message = this.extractCalendarDispositionNotify(data, alertClass);
      //break;

      case "pushNotificationNotify":
        _type = "danger";
        alertClass = "alert-danger";
        message = this.extractPushNotify(data, type, alertClass);

        break;
      case "realTimeNotificationNotify":
        _type = this.extractRealTimeNotificationType(data);
        alertClass = `alert-${_type}`;
        message = this.extractRealTimeNotify(data, type, alertClass);
        if (data.category === "AuthRequest" && data.token) {
          //setting Authorization data 
          manageOverRideService.setAuthData(data);
        }
        break;
      default:
        break;
    }

    notificationService.sendMessage(message, _type, "", 10);
  };

  extractCalendarNotify = (data, type, alertClass) => (
    <a
      className=""
      href="#item"
      onClick={(e) => this.onNotificationClick(e, data, type)}
    >
      {data.contractId === "00000000-0000-0000-0000-000000000000" && (
        <span className={`text-sm ${alertClass} mb-0`}>
          {" "}
          You scheduled a meeting to start right now:{" "}
          <span className={`h5 ${alertClass}`}>{data.title}</span>&nbsp;(
          <span>{data.message}</span>).
        </span>
      )}

      {data.contractId !== "00000000-0000-0000-0000-000000000000" && (
        <span className={`text-sm ${alertClass} mb-0`}>
          You scheduled a meeting to start right now:{" "}
          <span className={`h5 ${alertClass}`}>{data.title}</span>&nbsp;(
          <span>{data.message}</span>). Click to go to the client details.
        </span>
      )}
    </a>
  );

  extractCalendarReminderNotify = (data, type, alertClass) => (
    <a
      className=""
      href="#item"
      onClick={(e) => this.onNotificationClick(e, data, type)}
    >
      {data.contractId === "00000000-0000-0000-0000-000000000000" && (
        <span className={`text-sm ${alertClass} mb-0`}>
          {" "}
          Your next meeting{" "}
          <span className={`h5 ${alertClass}`}>{data.title}</span> is coming up
          at{" "}
          <span className={`h5 ${alertClass}`}>
            {moment(data.eventDate).format("HH:mm a")}
          </span>
          .
        </span>
      )}

      {data.contractId !== "00000000-0000-0000-0000-000000000000" && (
        <span className={`text-sm ${alertClass} mb-0`}>
          Your next meeting{" "}
          <span className={`h5 ${alertClass}`}>{data.title}</span> is coming up
          at{" "}
          <span className={`h5 ${alertClass}`}>
            {moment(data.eventDate).format("HH:mm a")}
          </span>
          . Click to go to the client details.
        </span>
      )}
    </a>
  );

  // extractCalendarDispositionNotify = (data, alertClass) =>
  //     <span><a className="list-group-item-action" href="#item" onClick={e => e.preventDefault()}>
  //         <p className={`text-sm ${alertClass} mb-0`}> Your appointment schedule <span className={`h5 ${alertClass}`}>{data.title}</span> has passed. Please select the disposition status below.</p>
  //     </a>
  //         <select className="form-control-sm" onChange={(e) => this.saveDispositionStatus(e.target.value, data.appointmentId, data.userId, -1)}>
  //             <option value="7">Unselected</option>
  //             <option value="2">No Show</option>
  //             <option value="3">Missed</option>
  //             <option value="4">Rescheduled</option>
  //             <option value="5">Complete</option>
  //         </select>
  //     </span>;

  extractPushNotify = (data, type, alertClass) => (
    <a
      className="list-group-item-action"
      href="#item"
      onClick={(e) => this.onNotificationClick(e, data, type)}
    >
      <p className={`text-sm ${alertClass} mb-0`}>
        {data.clientId && (
          <span>
            Client ID{" "}
            <span className={`h5 ${alertClass}`}>{data.clientId}</span>:{" "}
          </span>
        )}
        <span>{this.getPushNotificationMessage(data)}</span> &nbsp; Please click
        here to view the exception...
      </p>
    </a>
  );

  extractRealTimeNotify = (data, type, alertClass) => (
    <a
      className="list-group-item-action"
      href="#item"
      onClick={(e) => this.onRealTimeNotification(e, data, type)}
    >
      <p className={`text-sm ${alertClass} mb-0`}>
        <span className={`h5 ${alertClass}`}>
          {this.getRealTimeTitle(data)}
        </span>{" "}
        <span>{data.message}</span>
      </p>
    </a>
  );

  getRealTimeTitle = (data) => {
    return utils.isNullOrWhiteSpace(data.clientId)
      ? data.title
      : `# ${data.clientId}; ${data.title}`;
  };

  getPushNotificationMessage = (notification) => {
    switch (notification.exceptionType) {
      case "1": //PaymentFailed
        return "There was an exception(PaymentFailed).";
      case "2": //PaymentNotReceived
        return "There was an exception(PaymentNotReceived).";
      case "3": //PaymentDeclined
        return "There was an exception(PaymentDeclined).";
      case "4":
        return "There was an exception trying to push drafts."; //BulkDraftSaveFailed
      case "5":
        return "There was an exception trying to update drafts."; //BulkDraftUpdateFailed
      case "6":
        return "There was an exception trying to delete/suspend drafts."; //BulkDraftDeleteFailed
      case "7":
        return "There was an exception trying to cancel your client."; //ClientCancel
      case "8":
        return "There was an exception trying to create client."; //ClientCreate
      case "9":
        return "There was an exception trying to push your settlements."; //SettlementPush
      case "10":
        return "There was an exception trying to push your fees."; //FeePush
      case "11":
        return "There was an exception trying to upload your agreement."; //AgreementUpload
      case "20":
        return "There was an exception trying to update fee group."; //AgreementUpload
      default:
        return "There was an exception.";
    }
  };

  extractRealTimeNotificationType = (data) => {
    let type = "";
    switch (data.messageType) {
      case "Warning":
        type = "warning";
        break;
      case "Error":
        type = "danger";
        break;
      case "Success":
        type = "success";
        break;

      case "Info": // TO DO****************************INFO COLOR IS SAME WITH THEAM.
        type = "default";
        break;

      default:
        type = "default";
        break;
    }

    return type;
  };

  render() {
    const { notifications } = this.state;
    return (
      <Fragment>
        <audio autoPlay={false} ref={this.audio}>
          <source src={notificationAlertSrc} type="audio/mpeg"></source>
        </audio>
        <UncontrolledDropdown nav>
          <DropdownToggle
            className="nav-link"
            color=""
            tag="a"
            onClick={this.toggle}
          >
            <i className="ni ni-bell-55" />
            {notifications.length > 0 && notifications.some((x) => !x.isSeen) && (
              <Fragment>
                <div className="notify">
                  {" "}
                  <span className="heartbit"></span>{" "}
                  <span className="point"></span>{" "}
                </div>
              </Fragment>
            )}
          </DropdownToggle>
          <DropdownMenu className="dropdown-menu-xl py-0 overflow-hidden" right>
            <div className="px-3 py-3">
              <h6 className="text-sm text-muted m-0">
                You have{" "}
                <strong className="text-info">{notifications.length}</strong>{" "}
                notifications.
              </h6>
            </div>
            <PerfectScrollbar>
              <ListGroup style={{ maxHeight: "500px" }} flush>
                {notifications.map((notification, index) =>
                  this.extractNotificationMessage(notification, index)
                )}

                {notifications.length === 0 && (
                  <ListGroupItem
                    className="list-group-item-action"
                    href="#pablo"
                    onClick={(e) => e.preventDefault()}
                    tag="a"
                  >
                    <Row className="align-items-center">
                      <Col className="col-auto"></Col>
                      <div className="col ml--2">No Records.</div>
                    </Row>
                  </ListGroupItem>
                )}
              </ListGroup>
            </PerfectScrollbar>
            {/* <DropdownItem
                            className="text-center text-info font-weight-bold py-3"
                            href="#pablo"
                            onClick={e => e.preventDefault()}
                        >
                            View all
                    </DropdownItem> */}
          </DropdownMenu>
        </UncontrolledDropdown>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    companyCode: state.company.code,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onClientRedirect: (clientId) =>
      dispatch({
        type: actionTypes.CLIENT_REDIRECT,
        clientId: clientId,
      }),
    companyChange: (companyCode, callback) =>
      dispatch(companyChange(companyCode, callback)),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SignalrNotification);
